import React from 'react';
import PropTypes from 'prop-types';
import Form from '../../Form';
import { flat, expandExtended } from '../../../utils/flat';

class ParticipantCreationForm extends Form {
    static fieldsValidation = {
        name: ['required', ['minLength', 2]],
    };

    static propTypes = {
        ...Form.propTypes,
        isCreation: PropTypes.bool,

        onSubmit: PropTypes.func.isRequired,
    };

    static defaultProps = {
        ...Form.defaultProps,
        isCreation: false,
    };

    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (this.props.data !== props.data) {
            this.setState({ data: flat(props.data) });
        }
    }

    onSubmit(event) {
        event.preventDefault();

        if (this.isValid()) {
            this.props.onSubmit(expandExtended(this.state.data));
        }
    }

    renderForm() {
        const { isCreation } = this.props;

        return (
            <div className='participant-creation-form'>
                {this.getField(
                    <input
                        type='text'
                        label='Participant Name'
                        {...this.getFieldParameters('name')}
                    />
                )}
                <div className='row'>
                    <div className='col-8'>
                        {this.getField(
                            <input
                                type='text'
                                label='Feed Id'
                                {...this.getFieldParameters('platformObject.externalId.feedId')}
                            />
                        )}
                    </div>

                    <div className='col-4'>
                        {this.getField(
                            <select {...this.getFieldParameters('platformObject.externalId.provider')}>
                                {['spin', 'csv'].map((value) => (
                                    <option
                                        key={value}
                                        value={value}
                                    >
                                        {value}
                                    </option>
                                ))}
                            </select>
                        )}
                    </div>
                </div>

                <button
                    onClick={this.onSubmit.bind(this)}
                    className='btn btn-large'
                >
                    {isCreation ? 'Save new ' : 'Update '} participant
                </button>
            </div>
        );
    }
}

export default ParticipantCreationForm;
